module.exports = __webpack_public_path__ + "static/media/rare-icon.2fa99102.png";